import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { routes } from '../../../constants'
import storage from '../../../services/stoage.service'
import { actions } from '../teladinamica.actions'
import { TelaDinamicaForm } from './TelaDinamicaForm'
import { Button } from 'primereact/button'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import _ from 'lodash'
import { isArrayNotEmpty } from '../../../utils'
import { AgendarRelatorioDialog } from '../../../components/agendamentoRelatorio/AgendarRelatorioDialog'
import { podeAgendar } from '../../../components/agendamentoRelatorio/agendamentoRelatorio.utils'
import { getTelaDinamicaAgendavel } from '../../../components/agendamentoRelatorio/telaDinamicaAgendavel'
import { textoAgendamento } from '../../../components/agendamentoRelatorio/textos'
import { messageActions } from '../../../store/message'

const mapStateToProps = (state) => {
  const messages = state.crudTelaDinamicaState.messages
  const record = state.crudTelaDinamicaState.currentRecord
  const documento = state.crudTelaDinamicaState.documento

  return {
    messages,
    record,
    documento,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    loadDocumento: (oidDocumento) => dispatch(actions.loadDocumentoByOidMenu(oidDocumento)),
    executarRelatorio: ({ params, oidDocumento }) => dispatch(actions.executarRelatorio({ params, oidDocumento })),
    reset: () => dispatch(actions.reset()),
    mostrarSucesso: (mensagem) => dispatch(messageActions.showMessages([mensagem], 'success')),
  }
}

class TelaDinamicaFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.showPesquisarButton = false
    this.showCSVButton = false
    this.showColumnButton = false
    this.hideBtnImportacao = true
    this.state = {
      dadosFavorito: null,
      favorito: 0,
      agendarVisivel: false,
    }
    this.podeAgendar = podeAgendar(storage.getMenus(), routes.PATH_AGENDAMENTOS_RELATORIO)
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_TELA_DINAMICA_RELATORIO}`)
    }
    actions.afterLoadFavorito = (data) => {
      if (data && data.oid) {
        this.setState({ favorito: 1 })
        this.setState({ dadosFavorito: data })
      } else {
        this.setState({ favorito: 0 })
        this.setState({ dadosFavorito: null })
      }
    }
  }

  componentDidMount() {
    const oidCurrentMenu = storage.getOidCurrentMenu()
    if (oidCurrentMenu) {
      this.props.loadDocumento(oidCurrentMenu)
    }
  }

  componentWillUnmount() {
    this.props.reset()
  }

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  executarRelatorio = () => {
    const params = {}
    const record = _.get(this.props, 'record', {})
    for (const [key, value] of Object.entries(record)) {
      if (_.startsWith(key, 'oid_') && value) {
        const oid = value.map((v) => v.id)
        if (oid) {
          params[key] = oid
        }
      } else if (value) {
        params[key] = value
      }
    }

    const parametros = _.get(this.props, 'documento.parametros', null)
    if (!_.isEmpty(parametros)) {
      const array = JSON.parse(parametros)
      if (isArrayNotEmpty(array)) {
        const hiddenFields = array.filter((componentInfo) => _.get(componentInfo, 'componente', '') === 'hidden')
        if (!_.isEmpty(hiddenFields)) {
          hiddenFields.forEach((hiddenField) => {
            const campo = _.get(hiddenField, 'campo', null)
            const valor = _.get(hiddenField, 'valor', null)
            if (campo) {
              params[campo] = valor
            }
          })
        }
      }
    }
    const oidDocumento = _.get(this.props, 'documento.oid', null)
    this.props.executarRelatorio({ params, oidDocumento })
  }

  // agenda o registro da tela como esta (listas com rotulo, datas da tela); o back extrai os ids na execucao
  renderAgendar = () => {
    const agendavel = getTelaDinamicaAgendavel(this.props.documento)
    if (!agendavel) {
      return null
    }
    return (
      <AgendarRelatorioDialog
        visible={this.state.agendarVisivel}
        onHide={() => this.setState({ agendarVisivel: false })}
        relatorio={agendavel.relatorio}
        camposData={agendavel.camposData}
        EditorFiltros={agendavel.EditorFiltros}
        filtrosTela={_.get(this.props, 'record', {})}
        onSaved={() => this.props.mostrarSucesso(textoAgendamento('agendado'))}
      />
    )
  }

  getCustomButtons = () => {
    return (
      <div className="p-toolbar-group-left">
        <Button label="Visualizar" icon="pi pi-check" className="p-button-success" onClick={this.executarRelatorio} />
        {this.podeAgendar && _.get(this.props, 'documento.oid', null) && (
          <Button
            label={textoAgendamento('agendar')}
            icon="pi pi-clock"
            className="p-button-secondary"
            style={{ marginLeft: '.25em' }}
            onClick={() => this.setState({ agendarVisivel: true })}
          />
        )}
      </div>
    )
  }

  buildHeader = () => {
    return (
      <div>
        <DefaultToolBar listPageContainer={this} title={_.get(this.props, 'documento.nome', '')} />
      </div>
    )
  }

  render() {
    const content = (
      <TelaDinamicaForm
        messages={this.props.messages}
        record={this.props.record}
        setField={this.props.setField}
        history={this.props.history}
        documento={this.props.documento}
      />
    )

    return (
      <React.Fragment>
        <Page content={content} header={this.buildHeader()} />
        {this.podeAgendar && this.renderAgendar()}
      </React.Fragment>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TelaDinamicaFormPageContainer)
